module.exports = __webpack_public_path__ + "static/heroSmall.4d8843b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Img/Hero/heroSmall.jpg
// module id = 354
// module chunks = 213534597649335